import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const catalogAdminCatalogImageUploadsAccessConfiguration: DomainAccessControlConfig = {
  permissions: [Permission.ImageUploadsViewAccess],
}
